import React from 'react';
interface FooterProps {
  onTermsClick: () => void;
  onPrivacyClick: () => void;
  onContactClick: () => void;
}
export const Footer: React.FC<FooterProps> = ({
  onTermsClick,
  onPrivacyClick,
  onContactClick
}) => {
  return <footer className="w-full bg-[#444] text-white py-8 px-4 mt-auto" data-id="element-125">
      <div className="max-w-6xl mx-auto" data-id="element-126">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-127">
          <div data-id="element-128">
            <p className="text-sm text-gray-300" data-id="element-129">
              © {new Date().getFullYear()} Kit de Cuidado en el Postparto.
              Todos los derechos reservados.
            </p>
          </div>
          <div className="flex gap-6" data-id="element-130">
            <button onClick={onTermsClick} className="text-sm text-gray-300 hover:text-white transition-colors" data-id="element-131">
              Términos y condiciones
            </button>
            <button onClick={onPrivacyClick} className="text-sm text-gray-300 hover:text-white transition-colors" data-id="element-132">
              Política de privacidad
            </button>
            <button onClick={onContactClick} className="text-sm text-gray-300 hover:text-white transition-colors" data-id="element-133">
              Contacto
            </button>
          </div>
        </div>
      </div>
    </footer>;
};